'use strict';

import Routing from '../../../vendor/friendsofsymfony/jsrouting-bundle/Resources';
Routing.setRoutingData(require('../resources/routes.json'));

export default Routing;
